/* eslint-disable */
export default {
  noActiveCalls: 'Geen actieve oproepen',
  noRecords: 'Geen resultaten gevonden.',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noRecords"@#@ @source: @#@"No results found."@#@
